<template>
    <section :class="[namespace(), skinStyle]">
        <ul :class="[mdsNS('list-group'), namespace('dragable-container')]">
            <li
                :class="[mdsNS('list-group__item'), namespace('dragable-item')]"
                v-for="(item, index) in dataList"
                :key="item.id"
            >
                <svg
                    :class="[namespace('grab-icon'), mdsNS('icon')]"
                    aria-labelledby="title"
                >
                    <title>Grab-Handle</title>
                    <use xlink:href="#grab-handle--s"></use>
                </svg>
                <a
                    href="javascript:void(0)"
                    :class="[
                        mdsNS('list-group__link'),
                        namespace('dragable-item__link')
                    ]"
                    v-on:click.prevent
                >
                    <span
                        :class="[
                            mdsNS('list-group__item-text'),
                            namespace('__item-label')
                        ]"
                        >{{ item.label }}</span
                    >
                    <span
                        :class="[
                            mdsNS('list-group__item-text'),
                            namespace('__item-name')
                        ]"
                        >{{ item.name }}</span
                    >
                    <svg
                        :class="[
                            mdsNS('icon list-group__link-icon'),
                            namespace('remove-icon')
                        ]"
                        v-if="showRemove"
                        @click.stop="onRemove(index, $event)"
                        aria-labelledby="title"
                    >
                        <title>Remove</title>
                        <use xlink:href="#remove--s"></use>
                    </svg>
                </a>
            </li>
        </ul>
    </section>
</template>
<script>
import mwcMarketsCore from 'mwc-markets-core';
import forexBasicMixin from '../mixin';
import Sortable from 'sortablejs';
const { utils } = mwcMarketsCore;
export default {
    name: 'markets-ui-dragable-list',
    mixins: [forexBasicMixin],
    props: {
        dataModel: {
            type: Array,
            default() {
                return [];
            }
        },
        showRemoveIcon: {
            type: Boolean,
            default: true
        },
        minNumber: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            dataList: []
        };
    },
    created() {
        this.namespace = utils.namespace('ui-drable-list', false);
        this.dataList = utils.extend(true, [], this.dataModel);
    },
    mounted() {
        const dragableEl = this.$el.querySelector(
            `.${this.namespace('dragable-container')}`
        );
        this.initSorting(dragableEl);
    },
    computed: {
        showRemove() {
            return this.showRemoveIcon && this.dataList.length > this.minNumber;
        },
        skinStyle() {
            const skinSuffix = utils.getSkinSuffix(this.skin);
            return `${this.mdsNS(
                'container'
            )}--${skinSuffix} ${this.namespace()}--${skinSuffix} `;
        }
    },
    watch: {
        dataModel: {
            handler(value) {
                this.dataList = utils.extend(true, [], this.dataModel);
            },
            deep: true
        }
    },
    methods: {
        initSorting(el) {
            this.$_sortable = Sortable.create(el, {
                onEnd: this.onDragEnd
            });
        },
        onDragEnd(e) {
            if (e.oldIndex !== e.newIndex) {
                const item = this.dataList.splice(e.oldIndex, 1)[0];
                this.dataList.splice(e.newIndex, 0, item);
                this.$emit('change', this.dataList);
            }
        },
        onRemove(index) {
            this.dataList.splice(index, 1);
            this.$emit('change', this.dataList);
        }
    }
};
</script>
<style lang="scss">
$namespace: 'markets-ui-drable-list';
@mixin group-item-font {
    font-family: $mds-font-family-sans-serif;
    font-size: $mds-font-size-s;
}
@import 'morningstar-design-system/constants/constants.scss';
.#{$namespace} {
    max-height: 200px;
    min-height: 50px;
    overflow-y: auto;
    width: 100%;
    &-dragable-container {
        font-size: $mds-font-size-s;
    }
    &-dragable-item {
        @include group-item-font;
        display: flex;
        padding: 3px;
        align-items: center;
        margin-left: -7px;
        &__link {
            display: flex;
            width: 100%;
            align-items: center;
            &:hover {
                fill: $mds-text-color-link-on-light;
            }
        }
    }
    &-grab-icon {
        height: 15px;
        width: 15px;
    }
    &-remove-icon {
        height: 12px;
        width: 12px;
    }
    &__item-label {
        flex-basis: 130px;
    }
    &__item-name {
        flex-basis: 35px;
    }
    &__header {
        margin-bottom: $mds-space-1-x;
        &-title {
            display: inline-flex;
            align-items: center;
            button {
                margin-right: $mds-space-three-quarter-x;
            }
        }
    }
}
.#{$namespace}--dark-gray {
    .#{$namespace} {
        &-grab-icon,
        &-remove-icon {
            fill: $mds-text-color-primary-on-dark;
        }
    }
}
</style>
